import script from "./TronDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TronDetails.vue?vue&type=script&setup=true&lang=js"

import "./TronDetails.vue?vue&type=style&index=0&id=923db23c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-923db23c"]])

export default __exports__